import { Center, Flex, Text } from '@chakra-ui/react';
import { useAgentHolderInfo } from '@ui/hooks/api/useAgentHolderInfo';

import { useBondingTradeDialog } from '../../useBondingTradeDialog';
import { BondingTradeFromTokenCard } from './BondingTradeFromTokenCard';
import { BuySellToggle } from './BuySellToggle';

export const BondingTradeForm = () => {
  const bondingTokenAddress = useBondingTradeDialog(
    (s) => s.bondingTokenAddress,
  );
  const holders = useAgentHolderInfo(bondingTokenAddress).data;

  return (
    <Flex flexDir="column">
      <Center>
        <BuySellToggle />
      </Center>
      <BondingTradeFromTokenCard mt="24px" />
      {!!holders && holders.totalHolder <= 19 && (
        <Text mt="8px" textStyle="body3Bold" color="primary">
          Be one of the top 20 holders by buying this agent token now!
        </Text>
      )}
    </Flex>
  );
};
